import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SharedDataService } from 'elbuild-ui-lib-core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OrderReturnMode, Paymode } from 'yf-commerce-model-ui-lib';

@Injectable({
	providedIn: 'root'
})
export class SectionsService {



	private subsections = new BehaviorSubject<{ title: string, label: string, link?: string, dasboard?: boolean, class?: string }[]>(undefined);
	currentSubsections = this.subsections.asObservable();


	showCards: boolean;
	returnmode: OrderReturnMode;

	constructor(private sharedDataService: SharedDataService, private router: Router) {

		this.sharedDataService.currentCommondata.subscribe(data => {
			if (data) {
				if (data['allowedpayments'] != undefined)
					this.showCards = !!(data.allowedpayments as string).split(',').find(s => s === Paymode.STRIPE || s === Paymode.STRIPE_V2);
				this.returnmode = data.returnmode;
				this.setSubsections();

			}
		});



	}


	navigateTo(sub: { title: string; label: string; link?: string; class?: string }) {
		if (sub.link) {
			location.href = sub.link;
		} else {
			this.router.navigateByUrl('/account' + (sub.title == 'account' ? '' : '/' + sub.title));
		}
	}
	setSubsections() {
		let subsections0: { title: string, label: string, icon?: string, link?: string, dashboard?: boolean, class?: string }[] = [
			{
				title: 'home',
				label: 'home'
			}];

		if (environment.customsections) {
			for (const element of environment.customsections) {
				subsections0.push({
					title: 'extra/' + element,
					label: element,
					dashboard: true,
					class: 'extra'
				})
			}
		}

		subsections0 = [...subsections0,
		{
			title: 'wishlist',
			label: 'wishlist',
			link: environment.wishlistURL,
			dashboard: true
		},

		{
			title: 'profile',
			label: 'profile'
		},
		{
			title: 'change-password',
			label: 'change-password'
		},
		{
			title: 'orders',
			label: 'my-orders',
			dashboard: true
		},
		{
			title: 'shippingaddress',
			label: 'my-shipping-address',
			dashboard: true
		},
		{
			title: 'billingaddress',
			label: 'my-billing-address'
		}];

		if (environment.showdocuments) {
			subsections0.push({
				title: 'documents-history',
				label: 'b2b.documents-history'
			});
		}

		const subsections1 = [{
			title: 'returns',
			label: 'my-order-returns'
		}
		];

		const sectionCard = [
			{
				title: 'cards',
				label: 'my-cards',
				dashboard: true
			},
		];
		let subsections;

		if (this.returnmode === OrderReturnMode.OFF) {
			subsections = [...subsections0];
		} else {
			subsections = [...subsections0, ...subsections1];
		}

		if (this.showCards) {
			subsections = [...subsections, ...sectionCard];
		}


		this.subsections.next(subsections);
	}
}
